export default  {
  apiKey: "AIzaSyBBOXRlc6qAQuj1G7oeA0yiBe1rcKLsBpY",
  authDomain: "treinosapp-1bf57.firebaseapp.com",
  projectId: "treinosapp-1bf57",
  storageBucket: "treinosapp-1bf57.appspot.com",
  messagingSenderId: "121457524417",
  appId: "1:121457524417:web:ffffa532c1e3b78f1d5e40",
  measurementId: "G-ZFSGT9S3P0"
};